import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-necesitoayuda',
  templateUrl: './necesitoayuda.component.html',
  styleUrls: ['./necesitoayuda.component.css']
})
export class NecesitoayudaComponent implements OnInit {
lenguaje="es"
  constructor(    private translate: TranslateService) { }

  ngOnInit(): void {
    this.lenguaje = localStorage.getItem('idioma');
  }

}
